import React, { useState, useEffect, useReducer, createContext } from 'react';
import { languageOptions, labelsList } from '../../services/Language';
import { fetchLabelTranslation } from '../../store/actionSelectors';
import { FETCH_LABEL_TRANSLATION } from '../../store/actionTypes';
import { LabelTranslationReducer } from '../../store/reducer';
import { enGB, fr, nl, de } from 'date-fns/locale';
import {registerLocale, setDefaultLocale} from 'react-datepicker';

const localeList = [enGB, fr, nl, de];

const initialState = {
    language: languageOptions[0] 
}

export const LanguageContext = createContext();

export function LanguageProvider(props) {
    let [state, dispatch] = useReducer(LabelTranslationReducer, initialState);
    const [isLoaded, setIsLoaded] = useState(false);
    const { language, labels } = state;
    
    const fetchLabels = async (selectedLanguage) => {
        if(props.isAuthenticate) {
        await fetchLabelTranslation(selectedLanguage.id)
            .then((data) => {
                setIsLoaded(true);
                dispatch({ type: FETCH_LABEL_TRANSLATION, payload: { language: selectedLanguage, labels: data } });
            })
            .catch((error) => {
            })
        } else {
            dispatch({ type: FETCH_LABEL_TRANSLATION, payload: { language: selectedLanguage, labels: getUnAuthenticatedLabelsList(selectedLanguage) } });
        }
    }

    function getUnAuthenticatedLabelsList(selectedLanguage) {
        const langText=languageOptions[(+selectedLanguage.id)-1].text;
        const labelsData = labelsList[langText];
        return labelsData; 
    }

    useEffect(()=> {    
        const langOption = languageOptions[(+props.prefLangCode)-1];
            dispatch({ type: FETCH_LABEL_TRANSLATION, payload: { language: langOption, 
                labels: getUnAuthenticatedLabelsList(langOption) } });                
    }, []);

    // useEffect(()=> {   
    //     if(props.prefLangCode)
    //     {
    //         setTimeout(() => {
    //             const langOption = languageOptions[(+props.prefLangCode)-1];
    //             dispatch({ type: FETCH_LABEL_TRANSLATION, payload: { language: langOption, 
    //                 labels: fetchLabels(langOption) } });      
    //         }, 2000);
    //     }           
    // }, [props.prefLangCode]);

    useEffect(() => {        
        async function fetchLabelsAsync() {
            if (!isLoaded) {               
                const langOption = languageOptions[(+props.prefLangCode)-1]; 
                props.prefLangCode && (langOption.id !== language.id) ? await fetchLabels(langOption) : await fetchLabels(language)
             }
        }
        fetchLabelsAsync();
    }, [isLoaded, props.isAuthenticate, props.prefLangCode]);

    const languageChangeHandler = (selectedLanguage) => {        
        fetchLabels(selectedLanguage);       
        registerLocale(selectedLanguage.text, localeList[selectedLanguage.id-1]);
        setDefaultLocale(selectedLanguage.text); 
    }

    const provider = {
        language: language,
        labels,
        onLanguageChange: languageChangeHandler
    };

    return (
        <LanguageContext.Provider value={provider}>
            {props.children}
        </LanguageContext.Provider>
    );
}